import * as Yup from 'yup';
import { getWarehouseVehicleSetupShape } from 'validators/Common/baseWarehouseVehicleSetupValidator';

export class UpdateWarehouseVehicleSetupValidator {
  public get schema() {
    return Yup.object().shape({
      ...getWarehouseVehicleSetupShape(),
    });
  }
}
